<template>
  <div>
    <highcharts :key="hcKey" :options="chartOptions"></highcharts>
  </div>
</template>

<script>
import { setChartMenuItemsLang } from '../../../utils/formatter'

export default {
  props: {
    value: {
      type: Object,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    animation: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      hcKey: 0,
    }
  },

  computed: {
    chartOptions: function () {
      const vueThis = this
      return {
        lang: this.setOptions,
        boost: {
          seriesThreshold: 2,
          usePreAllocated: true,
        },
        chart: {
          height: '50%',
          zoomType: 'xy',
          margin: [50, 20, 50, 80],
          backgroundColor: '#FFFFFF',
          animation: vueThis.animation,
        },
        tooltip: {
          formatter: function () {
            const min = this.point.x
            const max = this.point.x2 > 1 ? 1 : this.point.x2
            return vueThis.$n(min, 'percent') + ' - ' + vueThis.$n(max, 'percent')
          },
        },
        credits: {
          enabled: false,
        },
        legend: {
          enabled: false,
        },
        title: {
          text: this.title,
          style: { fontSize: '25px', fontWeight: 'bold' },
        },
        plotOptions: {
          series: {
            binWidth: 0.05,
            cursor: 'pointer',
            events: {
              click: function (event) {
                vueThis.$emit('column-click', {
                  chartCategory: 'riy-gross-return-distribution-chart',
                  range: 'riy_gross_return_distribution',
                  isLastColumns: event.point.index === event.point.series.yData.length - 1,
                  min: event.point.x,
                  max: event.point.x2 > 1 ? 1 : event.point.x2,
                  name: event.point.series.name,
                })
              },
            },
          },
        },
        xAxis: {
          title: {
            text: this.$t('marketComparation.indices.costInd.RIYGrossReturn'),
          },
          allowDecimals: true,
          showLastLabel: true,
          endOnTick: true,
          tickInterval: 0.1,
          min: 0,
          max: 1,
          labels: {
            formatter: (val) => Math.round(val.value * 100) + '%' || 0,
          },
          plotLines: [
            {
              width: 4,
              zIndex: 5,
              value: this.getPlotLineValue,
              color: getComputedStyle(document.documentElement).getPropertyValue('--primary'),
            },
          ],
        },
        yAxis: {
          title: {
            text: this.$t('marketComparation.numberOfProducts'),
          },
          allowDecimals: false,
          showLastLabel: true,
          endOnTick: true,
        },
        series: [
          {
            name: 'series1',
            type: 'histogram',
            baseSeries: 'series1',
            // Explicit zIndex: the default yAxis grid zIndex is 1 — without this, the histogram
            // columns can render BELOW the grid on the search page, letting the horizontal
            // gridlines show through every bar. Forcing the series above the grid fixes the symptom
            // regardless of whatever container/reflow condition triggers the reversed order.
            zIndex: 2,
          },
          {
            type: 'scatter',
            id: 'series1',
            visible: false,
            data:
              Array.isArray(this.value.series1) && this.value.series1.length > 0
                ? this.value.series1.map((item) => item.value)
                : [],
          },
          {
            name: 'series2',
            type: 'histogram',
            baseSeries: 'series2',
            color: '#F0A9A9',
            zIndex: 2,
          },
          {
            type: 'scatter',
            id: 'series2',
            visible: false,
            data:
              Array.isArray(this.value.series2) && this.value.series2.length > 0
                ? this.value.series2.map((item) => item.value)
                : [],
          },
        ],
      }
    },

    getPlotLineValue() {
      return Array.isArray(this.value.series2) && this.value.series2.length > 0 ? this.value.series2[0].value : null
    },

    setOptions() {
      this.hcKey += 1
      return setChartMenuItemsLang()
    },
  },
}
</script>

<style lang="scss" scoped></style>
